import "@fontsource/oswald";
import HeaderBlue from '../../components/HeaderBlue';
import FooterBlue from '../../components/FooterBlue';

const News = () => {
    return (
        <>
            <HeaderBlue />
            {/* Hero Section */}
            <section className="w-full py-60 relative bg-cover bg-top px-3"
                style={{
                    backgroundImage: "url('./assets/news1.webp')",
                    backgroundSize: 'cover',
                    // backgroundPosition: 'center'
                }}>
                <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-white/10 z-0"></div>
                <div className="md:px-40 relative z-10">
                    <h2 className="text-white text-6xl font-bold font-oswald pb-5">NEWS & BLOGS </h2>
                    <p className="text-white text-xl font-semibold font-oswald">
                        Stay updated with the latest trends, regulations, and insights in the trucking industry.
                    </p>
                </div>
            </section>

            {/* News Grid */}
            <main className="max-w-7xl mx-auto py-12 px-6">
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {/* Articles */}
                    {newsData.map((article, index) => (
                        <div key={index} className="bg-white rounded-xl shadow border p-6 hover:shadow-lg hover:scale-105 transition">
                            <img src={article.image} alt="News" className="rounded-lg mb-4 w-full h-44 object-cover" />
                            <p className="text-sm text-gray-500 mb-2"><i className="fas fa-calendar-alt"></i> {article.date}</p>
                            <h3 className="text-xl font-bold text-blue-700 mb-2">{article.title}</h3>
                            <p className="mb-4 text-gray-800">{article.excerpt}</p>
                            <a href="#" className="text-black font-semibold flex items-center gap-1 hover:text-blue-800">
                                <i className="fas fa-arrow-right"></i> Read More
                            </a>
                        </div>
                    ))}
                </div>
            </main>
            <FooterBlue />
        </>
    );
};

const newsData = [
    {
        image: "https://tse3.mm.bing.net/th?id=OIP.DkMx9qxDHzmCEvLUJqN7HQHaEK&pid=Api&P=0&h=180",
        date: "June 5, 2025",
        title: "New FMCSA Regulations for 2025",
        excerpt: "The Federal Motor Carrier Safety Administration has introduced new hours-of-service rules to enhance driver safety and flexibility. Key changes include..."
    },
    {
        image: "https://tse4.mm.bing.net/th/id/OIP.ftI5YGRAumqlmTbp3Vm8IgHaEL?pid=Api&P=0&h=180",
        date: "June 1, 2025",
        title: "Electric Trucks Gain Traction",
        excerpt: "Major trucking companies are investing in electric fleets to reduce emissions. Learn how this shift is impacting drivers and logistics..."
    },
    {
        image: "https://tse3.mm.bing.net/th?id=OIP.W7NAIyUuZLZ9q5XCGxIEiAHaE8&pid=Api&P=0&h=180",
        date: "May 28, 2025",
        title: "Driver Shortage Solutions",
        excerpt: "Industry leaders discuss strategies to address the ongoing driver shortage, including better pay, benefits, and training programs..."
    },
    {
        image: "https://tse2.mm.bing.net/th?id=OIP.ANY_6HOyJQZqvCGRLuecYQHaEO&pid=Api&P=0&h=180",
        date: "May 20, 2025",
        title: "Tech Innovations in Trucking",
        excerpt: "From autonomous trucks to advanced telematics, new technologies are transforming the trucking industry. Explore the latest developments..."
    },
    {
        image: "https://tse3.mm.bing.net/th?id=OIP.nH_-eLM_zvGUn96KlKzJRwHaGS&pid=Api&P=0&h=180",
        date: "May 15, 2025",
        title: "Fuel Price Trends Impacting Trucking",
        excerpt: "Rising fuel costs are affecting trucking operations. Experts analyze current trends and offer tips for owner-operators to manage expenses..."
    },
    {
        image: "https://images.unsplash.com/photo-1581091226033-d5c48150dbaa?ixlib=rb-4.0.3&auto=format&fit=crop&w=1770&q=80",
        date: "May 10, 2025",
        title: "Spotlight On Veterans In Truck Driving",
        excerpt: "This Military Appreciation Month in May, Truckers honors the sacrifices and service of our veterans..."
    }
];

export default News;
